import type { WebBuildCardData } from '../../lib/conversationsApi';
import './websitePreviewCard.css';

export function WebsitePreviewCard({ webBuild }: { webBuild: WebBuildCardData }) {
  return (
    <section className="ozira-website-preview-card" aria-label={`Live preview of ${webBuild.projectName}`}>
      <div className="ozira-website-preview-card__brand">
        <span>OZIRA Live</span>
        <strong>Code workspace</strong>
        {webBuild.url ? (
          <a className="ozira-website-preview-card__open" href={webBuild.url} target="_blank" rel="noreferrer">
            Open in browser ↗
          </a>
        ) : null}
      </div>
      <iframe
        className="ozira-website-preview-card__frame"
        srcDoc={webBuild.html}
        sandbox="allow-scripts allow-forms allow-modals"
        title={webBuild.projectName}
      />
      <div className="ozira-website-preview-card__files">
        {webBuild.files.map((file) => (
          <span className="ozira-website-preview-card__file" key={file}>{file}</span>
        ))}
      </div>
    </section>
  );
}
